import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHero } from "@/components/PageHero";
import { ArticleCard } from "@/components/Cards";

const CATS = ["All", "CPR", "Pivot Points", "PCR", "Open Interest", "VWAP", "Trading Psychology"];

export default function KnowledgeCenter() {
  const [articles, setArticles] = useState([]);
  const [active, setActive] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/articles").then((r) => setArticles(r.data)).finally(() => setLoading(false));
  }, []);

  const filtered = articles.filter((a) => active === "All" || a.category === active);

  return (
    <div data-testid="knowledge-page">
      <PageHero
        eyebrow="Knowledge Center"
        title="KRV Prime Knowledge Center"
        subtitle="Educational articles on market basics, technical analysis, options, futures, risk management, trading psychology and market structure."
        crumbs={[{ label: "Knowledge Center" }]}
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="flex flex-wrap gap-2 mb-8" data-testid="article-filters">
          {CATS.map((c) => (
            <button
              key={c}
              onClick={() => setActive(c)}
              data-testid={`kc-cat-${c.toLowerCase().replace(/\s/g, "-")}`}
              className={`text-sm px-4 py-2 rounded-md border transition-colors ${active === c ? "bg-navy text-white border-navy" : "bg-white text-slate-600 border-border hover:border-navy/40"}`}
            >
              {c}
            </button>
          ))}
        </div>
        {loading ? (
          <p className="text-slate-400">Loading articles…</p>
        ) : (
          <div>{filtered.map((a) => <ArticleCard key={a.slug} article={a} />)}</div>
        )}
      </div>
    </div>
  );
}
